import { useAuth } from '@restworld/feature-authentication';

export function useIsFreemiumUser() {
  const { user } = useAuth();

  // With new PPU (Pay-Per-Use) business model, users are NEVER freemium
  if (user?.using_ppu_business_model) {
    return false;
  }

  // Legacy logic for old business model
  return !!user?.freemium_user;
}
